import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Typography, Box, CircularProgress } from '@material-ui/core';
import Icons from '../Icons';
import I18n from '../../../config/locales';

const useStyles = makeStyles(theme => ({
  scoreCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(4),
    minWidth: theme.spacing(15),
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
      minWidth: '40%'
    },
    [theme.breakpoints.down(360)]: {
      minWidth: '100%'
    }
  },
  scoreCardBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(0.5)
  },
  scoreCardValue: {
    display: 'flex',
    alignItems: 'center'
  },
  scoreLabel: {
    fontSize: 10,
    color: theme.palette.primary.dataBlack
  },
  scoreValue: {
    fontSize: 16,
    textTransform: 'capitalize',
    color: theme.palette.primary.main
  },
  scoreCardPeriod: {
    fontSize: 7,
    color: '#0000008a',
    marginLeft: theme.spacing(0.5)
  },
  star: {
    width: theme.spacing(4.2),
    height: theme.spacing(4)
  },
  calender: {
    width: theme.spacing(3.6),
    height: theme.spacing(4)
  },
  bookmark: {
    width: theme.spacing(3.6),
    height: theme.spacing(4)
  },
  smiley: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  home: {
    width: theme.spacing(4.1),
    height: theme.spacing(4.2)
  },
  energy: {
    width: theme.spacing(4.2),
    height: theme.spacing(4.1)
  },
  battery: {
    width: theme.spacing(4),
    height: theme.spacing(4.4)
  }
}));

const ScoreCard = props => {
  const classes = useStyles();
  const { value, label, icon, period = '', npsScoreUpdated = true, valueId = '' } = props;
  const Icon = Icons[icon];
  const isValueEmpty = value === undefined || value === null || value === '';
  const cardValue = isValueEmpty ? '-' : value;
  return (
    <Box className={classes.scoreCard}>
      <Avatar variant="square" alt="score-card-label" src={Icon} className={classes[icon]} />
      <Box className={classes.scoreCardBody}>
        <Typography component="div" className={classes.scoreLabel}>
          {label}
        </Typography>
        <Box className={classes.scoreCardValue}>
          {!npsScoreUpdated ? (
            <CircularProgress size={15} />
          ) : (
            <Typography component="div" className={classes.scoreValue} id={valueId && valueId}>
              {cardValue}
            </Typography>
          )}
          {!isValueEmpty &&
          period && (
            <Typography component="div" className={classes.scoreCardPeriod}>
              {`( ${I18n.t('dashboard.lastMonth', { count: period })} )`}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ScoreCard;
